import { z } from "zod";
import { MetaSchema } from "./shared";
import { TransferPaymentFineEnum } from "../enums";

export const PlatformOverviewSchema = z.object({
  totalAmount: z.string(),
  totalCountOfActiveLoans: z.number(),
  totalCountOfInactiveLoans: z.number(),
  totalUsers: z.number(),
});

export const UserLoanSchema = z.object({
  id: z.string().uuid(),
  uid: z.number(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
  paidInstallments: z.number(),
  status: z.string(),

  liquidityValue: z.string(),
  marginCallValue: z.string(),
  freeMarginValue: z.string(),

  amount: z.string(),
  targetLtv: z.string(),
  currentLtv: z.string(),
  remainingAmount: z.string(),

  reliability: z.string(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  receivedCurrency: z.string(),

  initialCollateralPrice: z.string(),
  unpaidInstallments: z.number(),
  collateralAmount: z.string(),

  transferredAmount: z.string().nullable(),
  purpose: z.string(),
  penalty: z.any().nullable(),

  monthlyRepay: z.string(),

  acceptedAt: z.string().nullable(),
  nextRepaymentDate: z.string().datetime(),
  lastInstallmentAt: z.string().nullable(),

  updatedAt: z.string().datetime(),
  createdAt: z.string().datetime(),
});

export const InstallmentSchema = z.object({
  id: z.string().uuid(),
  amount: z.string(),
  latePenalty: z.string(),
  latePenaltyPerOnDays: z.number(),
  transactionType: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  dueDate: z.string().datetime(),
  uid: z.number(),
  lastCalculateLatePenalty: z.string().nullable(),
  details: z.any().nullable(),
  createdAt: z.string().datetime(),
  paymentAt: z.string().nullable(),
  updatedAt: z.string().datetime(),

  userLoan: UserLoanSchema,
});

export const InstallmentSummarySchema = z.object({
  count: z.number(),
  totalAmount: z.number(),
});

export const PenaltySummarySchema = z.object({
  count: z.number(),
  totalAmount: z.number(),
});

export const UserOverviewSchema = z.object({
  nextNotPaidInstallment: InstallmentSchema.nullable().optional(),

  userLoansCount: z.number().optional(),

  totalInstallments: InstallmentSummarySchema.optional(),

  totalPaidInstallments: InstallmentSummarySchema.optional(),

  totalRemainingInstallments: InstallmentSummarySchema.optional(),

  totalPenalty: PenaltySummarySchema.optional(),
});

export const LoansOverviewDataSchema = z.object({
  platformOVerview: PlatformOverviewSchema,
  userOverview: UserOverviewSchema.optional(),
});

export const LoansOverviewResponse = z.object({
  data: LoansOverviewDataSchema,
  meta: MetaSchema.default,
});

export type LoansOverviewResponseType = z.infer<typeof LoansOverviewResponse>;
export default LoansOverviewResponse;
